import { useApplicationScreenshotsQuery } from './useApplicationScreenshotsQuery';
import { useApplicationScreenshotsSearch } from './useApplicationScreenshotsSearch';
import { columns } from '../tables/columns';

export const useApplicationScreenshots = (filters: Record<string, string> = {}) => {
    const { data: items = [], isLoading: loading } = useApplicationScreenshotsQuery(filters);
    const { keyword } = useApplicationScreenshotsSearch();

    // Filter items based on keyword (client-side filtering)
    const visibleItems = items.filter(item =>
        !keyword ||
        item.url?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.path?.toLowerCase().includes(keyword.toLowerCase()) ||
        item.status?.toLowerCase().includes(keyword.toLowerCase())
    );

    return {
        items,
        visibleItems,
        loading,
        columns,
    };
};
